import styled from "styled-components";
import { Swiper } from "swiper/react";

export const TextTitle = styled.span`
  color: #000;
  leading-trim: both;
  text-edge: cap;
  font-feature-settings: "ss01" on;
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  @media screen and (max-width: 1366px) {
    font-size: 24px;
  }
  @media screen and (max-width: 1023px) {
    font-size: 18px;
  }
`;
export const TextTitleLink = styled.span`
  color: #000;
  font-feature-settings: "ss01" on;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const TextTitleCard = styled.span`
  color: #fff;
  font-family: Montserrat;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  @media screen and (min-width: 1024px) and (max-width: 1366px) {
    font-size: 21px;
  } 
  @media screen and (max-width: 1024px) {
    font-size: 16px;
  }
`;

export const TextMoney = styled.div`
  color: #F12E11;
  font-family: Montserrat;
  font-size: 38.632px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  @media screen and (max-width: 1024px) {
    font-size: 30px;
  }
`;
export const TextTitleCard2 = styled.span`
  color: #fff;
  font-family: Montserrat;
  font-size: 25.755px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
export const Text2 = styled.span`
  color: #fff;
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  @media screen and (min-width: 1024px) and (max-width: 1366px) {
    font-size: 16.875px;
  } 
  @media screen and (max-width: 1024px) {
    font-size: 16px;
  }
  & .money {
    color: #F12E11;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    @media screen and (max-width: 1024px) {
      font-size: 20px;
    }
  }
`;

export const Text3 = styled.span`
  color: #F12E11;
  font-family: Montserrat;
  font-size: 25.755px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  @media screen and (max-width: 1024px) {
    font-size: 20px;
  }
`;

export const Text4 = styled.span`
  color: #000;
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-feature-settings: "ss01" on;
  font-family: Switzer;
  font-size: 31.934px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  @media screen and (min-width: 1024px) and (max-width: 1366px) {
    font-size: 26.944px;
  } 
  @media screen and (max-width: 1024px) {
    font-size: 24px;
  }
  @media screen and (max-width: 370px) {
    font-size: 18px;
  }
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const Text5 = styled.span`
  color: #989898;
  text-align: center;
  font-feature-settings: "ss01" on;
  font-family: Switzer;
  font-size: 15.967px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.612px;
  @media screen and (min-width: 1024px) and (max-width: 1366px) {
    font-size: 13.472px;
  } 
  @media screen and (max-width: 1024px) {
    font-size: 12px;
  }
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const Text6 = styled.span`
  color: #fff;
  text-align: center;
  font-family: Montserrat;
  font-size: 20.604px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  @media screen and (max-width: 1024px) {
    font-size: 16px;
  }
`;

export const Text7 = styled.span`
  color: #000;
  font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  @media screen and (max-width: 1366px) {
    font-size: 24px;
  }
  @media screen and (max-width: 1024px) {
    font-size: 22px;
  }
`;

export const Text8 = styled.span`
  color: #989898;
  leading-trim: both;
  text-edge: cap;
  font-feature-settings: "ss01" on;
  /* Heading/H4-M-Sm */
  font-family: Switzer;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Text9 = styled.span`
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Text10 = styled.span`
  color: #F12E11;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;


export const Text11 = styled.span`
color: #FFF;
font-family: Montserrat;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: normal;
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  font-size: 13.5px;
} 
@media screen and (max-width: 350px) {
  font-size: 15px;
} 
`;

export const Text12 = styled.span`
color: #F12E11;
  font-family: Montserrat;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  @media screen and (min-width: 1024px) and (max-width: 1366px) {
  font-size: 21px;
} 
  @media screen and (max-width: 1024px) {
    font-size: 20px;
  }
`;

export const Text13 = styled.span`
  color: #F12E11;
  font-family: Montserrat;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  @media screen and (min-width: 1024px) and (max-width: 1366px) {
    font-size: 33px;
  } 
  @media screen and (max-width: 1023px) {
    font-size: 30px;
  }
`;

export const Text14 = styled.span`
  color: #F12E11;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
`;

export const Text15 = styled.span`
  color: #1B559F;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
`;

export const Text16 = styled.span`
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  @media screen and (max-width: 370px) {
    font-size: 14px;
  }
`;

export const SwiperWraperAffiliate = styled(Swiper)`
  & .swiper-slide > div {
    margin-left: auto;
    margin-right: auto;
  }
  & .swiper-button-prev,
  & .swiper-button-next {
    color: #000;
  }
`;
